export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/patient/privacy-policy/index.js